import getters from "@/store/modules/services/getters";

export default {
    namespaced: true,
    state() {
        return {
            services: [
                {
                    id: 'sr01',
                    title: 'Graphic Design',
                    description: 'It is a long established fact that a reader will be distracted,',
                    img: '470X390.png'
                },
                {
                    id: 'sr02',
                    title: 'Graphic Design',
                    description: 'It is a long established fact that a reader will be distracted,',
                    img: '470X390.png'
                },
                {
                    id: 'sr02',
                    title: 'Graphic Design',
                    description: 'It is a long established fact that a reader will be distracted,',
                    img: '470X390.png'
                },
                {
                    id: 'sr04',
                    title: 'Graphic Design',
                    description: 'It is a long established fact that a reader will be distracted,',
                    img: '470X390.png'
                },
            ],
        }
    },
    getters
}
